module.exports = "/static/assets/76cd1038baa3bca0d71a60cd1020438e.png";